import DOMPurify from 'dompurify';
import linkifyHtml, { LinkifyOptions } from 'linkify-html';
import React from 'react';
import { Typography, TypographyProps } from 'src/components/Typography';

interface HtmlTypographyProps extends TypographyProps {
  children: string;
  linkifyOptions?: LinkifyOptions;
}

export const HtmlTypography: React.FC<HtmlTypographyProps> = ({
  children,
  linkifyOptions = {},
  sx,
  ...typographyProps
}) => {
  const defaultLinkifyOptions: LinkifyOptions = {
    nl2br: true,
    target: '_blank',
    rel: 'noopener noreferrer',
  };

  const mergedOptions = { ...defaultLinkifyOptions, ...linkifyOptions };

  const sanitizedAndLinkedHtml = linkifyHtml(
    DOMPurify.sanitize(children),
    mergedOptions
  );

  return (
    <Typography
      component="span"
      {...typographyProps}
      sx={[
        { display: 'inline-block' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <span dangerouslySetInnerHTML={{ __html: sanitizedAndLinkedHtml }} />
    </Typography>
  );
};
